export default __webpack_public_path__ + "495d19614572c16a53c4681b3b3bd6ef.png";